import Skeleton from './skeleton';

export { type SkeletonProps } from './skeleton';

export default Skeleton;
